var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedPositionsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5296_14892)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.145508,
    width: 52,
    height: 52,
    rx: 12,
    fill: "#FFEBEE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0462 23.0735L35.9872 20.0292C36.1345 19.9403 36.3199 20.0597 36.2996 20.2298L34.5746 33.3388L28.8304 29.7754C28.9432 29.4685 29.0048 29.1371 29.0048 28.7915C29.0048 27.2147 27.7226 25.9325 26.1458 25.9325C25.3307 25.9325 24.5942 26.2752 24.073 26.8242L16.2187 21.9518L15.9921 20.2298C15.9693 20.0597 16.1572 19.9403 16.3019 20.0292L21.2455 23.0735L25.9808 16.7538C25.9999 16.7284 26.0246 16.7077 26.053 16.6935C26.0814 16.6793 26.1128 16.6719 26.1446 16.6719C26.1764 16.6719 26.2077 16.6793 26.2361 16.6935C26.2646 16.7077 26.2893 16.7284 26.3083 16.7538L31.0462 23.0735ZM16.4043 23.3621L17.932 34.9716C17.9599 35.1722 18.1326 35.327 18.3382 35.327H33.956C34.1591 35.327 34.3343 35.1747 34.3597 34.9716L34.417 34.5362L28.2587 30.7159C27.7354 31.2898 26.9821 31.6505 26.1458 31.6505C24.5691 31.6505 23.2869 30.3683 23.2869 28.7915C23.2869 28.4252 23.3561 28.0748 23.4821 27.7527L16.4043 23.3621ZM24.93 28.6509C24.9247 28.6971 24.922 28.744 24.922 28.7915C24.922 29.4669 25.4705 30.0179 26.1458 30.0179C26.3921 30.0179 26.6215 29.9449 26.8136 29.8194L24.93 28.6509ZM27.3673 28.8678C27.3689 28.8426 27.3697 28.8171 27.3697 28.7915C27.3697 28.1161 26.8212 27.5651 26.1458 27.5651C25.9226 27.5651 25.7132 27.6251 25.5329 27.7298L27.3673 28.8678Z",
    fill: "#EF5350"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5296_14892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(0.145508)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedPositionsIcon);
export default __webpack_public_path__ + "static/media/closed-positions-icon.0d0a47ce12fefdb2e86cfe6481aacfd5.svg";
export { ForwardRef as ReactComponent };